import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { User } from '../../models/identity/user.model';

@Injectable()
export class ChatBridgeService {
    private _openConversation$ = new Subject<User>();
    openConversation$ = this._openConversation$.asObservable();

    openConversation(user: User) {
        this._isChatModalOpen$.next(true); // Open modal first
        this._openConversation$.next(user);
    }

    private _isChatModalOpen$ = new BehaviorSubject<boolean>(false);
    isChatModalOpen$ = this._isChatModalOpen$.asObservable();

    openModal() {
        this._isChatModalOpen$.next(true);
    }

    closeModal() {
        this._isChatModalOpen$.next(false);
    }

    toggleModal() {
        this._isChatModalOpen$.next(!this._isChatModalOpen$.value);
    }


}
